import { FuelButton, FuelTypography } from '@frete.com/fuel-react';
import { FuelFlex, FuelModal } from '@frete.com/fuel-station-react';
import { DS_TOKENS } from 'constants/styled.contants';
import { useDeviceSize } from 'hooks/useDeviceSize';
import { useTruckerProps } from 'hooks/useTruckerProps';
import React, { FC } from 'react';

type RemoveContactModalProps = {
  isModalOpen: boolean;
  handleDialogState: () => void;
  handleCancelRemove: (event: React.MouseEvent) => void;
  handleConfirmRemove: (event: React.MouseEvent) => void;
};

const RemoveContactModal: FC<RemoveContactModalProps> = ({
  isModalOpen,
  handleCancelRemove,
  handleDialogState,
  handleConfirmRemove,
}) => {
  const { portalName } = useTruckerProps();
  const { isMobile } = useDeviceSize();
  const buttonsSize = 'medium';

  return (
    <FuelModal
      isOpen={isModalOpen}
      portalName={portalName}
      onClose={/* istanbul ignore next */ () => handleDialogState()}
      showCloseButton
      width="sm"
      removePortalOnDestroy={false}
    >
      <FuelTypography
        color="neutral-strong"
        size="heading-sm"
        weight="bold"
        spacingBottom={parseFloat(DS_TOKENS.spacing.km3)}
      >
        Remover contato
      </FuelTypography>
      <FuelTypography color="neutral-default" size="body-md" weight="regular" spacingBottom={24}>
        O contato será apagado da sua lista, tem certeza que deseja continuar?
      </FuelTypography>

      <FuelFlex defaultProps={{ justifyContent: 'flex-end', gap: 'km2' }} smProps={{ justifyContent: 'space-between' }}>
        <FuelButton
          variant="tertiary"
          size={buttonsSize}
          fullWidth={isMobile}
          onClick={(event) => handleCancelRemove(event)}
          data-testid="cancel-button-modal"
        >
          Cancelar
        </FuelButton>
        <FuelButton
          variant="primary"
          size={buttonsSize}
          fullWidth={isMobile}
          onClick={(event) => handleConfirmRemove(event)}
          data-testid="confirm-button-modal"
        >
          Sim, continuar
        </FuelButton>
      </FuelFlex>
    </FuelModal>
  );
};
export default RemoveContactModal;
